import { Monitor, Moon, Sun } from "lucide-react";

import { useTheme, type ThemeChoice } from "../lib/theme";
import { Segmented } from "./Primitives";

/** System, light or dark; remembered per browser. */
export function ThemeSwitcher() {
  const [theme, setTheme] = useTheme();
  return (
    <Segmented<ThemeChoice>
      label="Theme"
      size="sm"
      value={theme}
      onChange={setTheme}
      options={[
        { value: "system", label: <Monitor size={14} aria-label="System theme" /> },
        { value: "light", label: <Sun size={14} aria-label="Light theme" /> },
        { value: "dark", label: <Moon size={14} aria-label="Dark theme" /> },
      ]}
    />
  );
}
